import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { mapData } from "../hooks";
import { SweetOrHotLadiesDTORaw } from "../models";

export abstract class SweetOrHotApi {
  static get = async () => {
    const response = GbApiRequestService.post("userRpc", null, {
      params: {
        type: JSON.stringify({
          dataMap: {
            mode: "GetResult",
          },
          processorClass: "SweetOrHot",
        }),
      },
    });

    const validatedData = await withSchemaValidation(
      Promise.resolve(response),
      SweetOrHotLadiesDTORaw,
    );

    return mapData(validatedData);
  };
}
